export default class ExceptionIssue {
  Number: number = 0
  Address: string = ""
  IsNew: boolean = false
}
